
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import WhyThisCourse from './components/WhyThisCourse';
import CourseCoverage from './components/CourseCoverage';
import ImplementationFramework from './components/ImplementationFramework';
import WhoItsFor from './components/WhoItsFor';
import OrganisationalOutcomes from './components/OrganisationalOutcomes';
import PricingSection from './components/PricingSection';
import CredibilitySection from './components/CredibilitySection';
import FAQSection from './components/FAQSection';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import StickyEnrolCTA from './components/StickyEnrolCTA';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <TrustStrip />
      <WhyThisCourse />
      <CourseCoverage />
      <ImplementationFramework />
      <WhoItsFor />
      <OrganisationalOutcomes />
      <PricingSection />
      <CredibilitySection />
      <FAQSection />
      <ContactCTA />
      <Footer />
      <BackToTop />
      <StickyEnrolCTA />
    </div>
  );
}
